import React, { useEffect } from 'react';
import './PlayerCardMercado.scss'; 
import { getImgTeam } from '../utils/utils.js';
import useLongPress from "../utils/useLongPress.js"
import cara from "../assets/img/cara-default.png";
import estrella from "../assets/img/estrella.png";

const PlayerCardMercado = ({ config, index, jugador, updateSelections, longPressActive, openDetails }) => {

    const onLongPress = () => {
        openDetails(index)
    };

    const onClick = () => {
        updateSelections(index)
    }
    const defaultOptions = {
        shouldPreventDefault: true,
        delay: 500,
    };

    const longPressEvent = useLongPress(onLongPress, onClick, defaultOptions);

    const getJugadorPoints = (jugador)=>{
        var puntos = 0
        var jornada = jugador.puntosEquipoJornada.length - 1
        puntos += jugador.puntosEquipoJornada[jornada]
        puntos += jugador.puntosJornada[jornada]
        puntos += jugador.puntosMvpJornada[jornada]
        return puntos
    }

    const getLastFiveJornadaPoints = (jugador)=>{
        let content = [];
        let numJornadas = jugador.puntosJornada.length
        var limite = numJornadas >=5 ? 5 : numJornadas
        for(let i=numJornadas-limite; i < numJornadas; i++){
            var puntos = 0
            puntos += jugador.puntosEquipoJornada[i]
            puntos += jugador.puntosJornada[i]
            puntos += jugador.puntosMvpJornada[i]
            var isStar = (jugador.puntosEquipoJornada[i] + jugador.puntosMvpJornada[i]) != 0
            content.push(
            <div className="jornada-container" key={jugador.nombre + jugador.numero + i}>
                <div className={puntos < 9 ? 'barra-color red' : puntos < 19 ? 'barra-color orange' : puntos < 40 ? 'barra-color green' : 'barra-color gold' } ></div>
                <div className='points'>{puntos}</div>
                {isStar &&
                    <img src={estrella} alt="Estrella" className="image-estrella-points" />
                }
            </div>);
        }
        return content
    }

    return (
        <div className={jugador.puntosJornada != null && (jugador.puntosEquipoJornada[jugador.puntosEquipoJornada.length - 1] > 0 || jugador.puntosMvpJornada[jugador.puntosMvpJornada.length - 1] > 0) ? "main-container-mercado jugador-estrella" : "main-container-mercado"} >
           <div className={"player-data-container-mercado"}> 
                <div className="player-image" onClick={()=> onLongPress()}>
                    <img src={jugador.foto != "" ? jugador.foto : cara} alt="Cara" className="player-face"/>
                </div>
                <div className='name-points-container'>
                    <div className="player-name">
                        {jugador.nombre}
                    </div>
                    <div className="points-list">
                        {getLastFiveJornadaPoints(jugador)}
                    </div>
                </div>
                <div className="team-image"  onClick={()=> updateSelections(index)}>
                    <img src={jugador.escudoClub} alt="Escudo" className={jugador.selected ? "image-team-selected" : "image-team-no-selected"} />
                </div>

                {jugador.puntosJornada != null && (jugador.puntosEquipoJornada[jugador.puntosEquipoJornada.length - 1] > 0 || jugador.puntosMvpJornada[jugador.puntosMvpJornada.length - 1] > 0) &&
                <div className="player-estrella">
                    <div className="player-estrella-img">
                        <img src={estrella} alt="Estrella" className="image-estrella" />
                    </div>
                </div>}
           </div>
           <div className={jugador.selected ? "player-selected" : ""}>

           </div>
            
        </div>
    );
};

export default PlayerCardMercado;